<template>
  <div class="app-otp-field">
    <div v-if="label" class="field-label">
      <v-icon v-if="labelIcon" size="18">{{ labelIcon }}</v-icon>
      <span>{{ label }}</span>
    </div>

    <v-otp-input
      v-model="model"
      :class="fieldClass"
      :variant="variant"
      :length="length"
      type="number"
      :divider="divider"
      :placeholder="placeholder"
      :masked="masked"
      :focus-all="focusAll"
      :error="Boolean(errorMessage)"
      v-bind="fieldAttrs"
    />

    <div v-if="errorMessage" class="field-error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<string | number | undefined>();

const props = withDefaults(
  defineProps<{
    variant?:
      | "solo"
      | "filled"
      | "outlined"
      | "plain"
      | "solo-filled"
      | "solo-inverted"
      | "underlined";
    label?: string;
    labelIcon?: string;
    length?: number | string;
    divider?: string;
    placeholder?: string;
    masked?: boolean;
    focusAll?: boolean;
    errorMessage?: string;
  }>(),
  {
    variant: "outlined",
    label: "",
    labelIcon: "",
    length: 6,
    divider: "",
    placeholder: "",
    masked: false,
    focusAll: false,
    errorMessage: "",
  },
);

const attrs = useAttrs();
const fieldClass = computed(() => ["app-otp-field__input", attrs.class]);

const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});
</script>

<style scoped>
.field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-subtitle);
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 6px;
}

.app-otp-field__input {
  width: 100%;
  /* background-color: #fff; */
}

.app-otp-field__input :deep(.v-otp-input) {
  width: 100%;
  padding: 0;
  justify-content: flex-start;
}

.app-otp-field__input :deep(.v-otp-input__content) {
  width: 100%;
  max-width: none;
  height: 48px;
  padding: 0;
  justify-content: space-between;
}

.app-otp-field__input :deep(.v-field) {
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: var(--radius-lg);
}

.app-otp-field__input :deep(.v-otp-input__field) {
  font-size: 0.875rem;
}

.field-error {
  margin-top: 6px;
  font-size: 12px;
  color: rgb(var(--v-theme-error));
}
</style>
